// 3D Planet: prijzen incl./excl. btw tonen (schakelaar in de bovenbalk, keuze in localStorage 'tdp-btw').
// Alle bedragen "€12,34" in de pagina worden bij 'excl' gedeeld door 1,21; het origineel blijft bewaard per tekstknoop.
(function () {
  var VAT = 1.21, KEY = 'tdp-btw', originals = new Map(), applying = false;
  var RE = /€\s?(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/g;
  function mode() { try { return localStorage.getItem(KEY) === 'excl' ? 'excl' : 'incl'; } catch (e) { return 'incl'; } }
  function fmt(cents) { var e = Math.floor(cents / 100), c = cents % 100; return '€' + e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (c < 10 ? '0' : '') + c; }
  function walk(root, fn) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var p = n.parentElement; if (!p) return NodeFilter.FILTER_REJECT;
      if (p.closest('script,style,textarea,input,.tdp-topbar__btw,[data-tdp-btw-ignore]')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT; } });
    var nodes = []; while (w.nextNode()) nodes.push(w.currentNode); nodes.forEach(fn);
  }
  function apply() {
    if (applying) return; applying = true;
    var excl = mode() === 'excl';
    walk(document.body, function (n) {
      var base = originals.has(n) ? originals.get(n) : n.nodeValue;
      if (!RE.test(base)) { RE.lastIndex = 0; return; }
      RE.lastIndex = 0;
      if (!originals.has(n)) originals.set(n, base);
      var out = excl ? base.replace(RE, function (m, e, c) { var cents = Math.round((parseInt(e.replace(/\./g, ''), 10) * 100 + parseInt(c, 10)) / VAT); return fmt(cents); }) : base;
      if (n.nodeValue !== out) n.nodeValue = out;
    });
    document.querySelectorAll('.tax-note, .cart-totals__tax-note').forEach(function (el) {
      if (!el.dataset.tdpBase) el.dataset.tdpBase = el.innerHTML;
      el.innerHTML = excl ? 'Prijzen exclusief btw; aan de kassa wordt 21% btw toegevoegd.' : el.dataset.tdpBase;
    });
    document.querySelectorAll('[data-tdp-btw]').forEach(function (b) { b.setAttribute('aria-checked', String(!excl)); });
    document.documentElement.classList.toggle('tdp-btw-excl', excl);
    var lab = document.getElementById('tdp-btw-label'); if (lab) lab.textContent = excl ? 'Excl. btw' : 'Incl. btw';
    applying = false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tdp-btw]'); if (!b) return;
    try { localStorage.setItem(KEY, mode() === 'excl' ? 'incl' : 'excl'); } catch (err) {}
    apply();
  });
  var pending = null;
  new MutationObserver(function () { if (applying) return; clearTimeout(pending); pending = setTimeout(apply, 120); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
